<div *ngIf="init && (!state.user || !state.service)" class="disabled-testing-alert">
  <div class="content">
    <div class="content-icon"><i class="icon-warning"></i></div>
    <div *ngIf="!state.service; then testingDisabledBlock else userDisabledBlock"></div>
    <ng-template #testingDisabledBlock>{{ serviceMessage }}</ng-template>
    <ng-template #userDisabledBlock>{{ userMessage }}</ng-template>
  </div>
</div>
